import { render, staticRenderFns } from "./OrderCleaningEdit.vue?vue&type=template&id=470e875c&scoped=true"
import script from "./OrderCleaningEdit.vue?vue&type=script&lang=js"
export * from "./OrderCleaningEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderCleaningEdit.vue?vue&type=style&index=0&id=470e875c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e875c",
  null
  
)

export default component.exports